import { createRouteContextObject } from '@shared/utils';
import { HttpContextBase } from '..';

export enum HttpContextRoutes {
  //Heartbeat
  SendHeartBeat,

  //UserDetails
  GetUserSession,
  SyncSelectedClient,
  SyncSelectedSubproject,
  SyncUserPreferences,
  GetProjectSetup,
  GetLastThreeDprs,
  GetUserManual,
  GetDprReportHistory,

  // Offline
  SyncOfflineChanges,
  SyncOfflineChangesExternalComments,
}

export const HttpSharedContext = createRouteContextObject(
  HttpContextBase.Shared,
  HttpContextRoutes
);
